module.exports = __webpack_public_path__ + "static/media/gas-pump.12d75192.svg";